import Info from '@assets/images/Info.svg';
import { useState } from 'react';

export const ExchangeRate = () => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div className='relative flex justify-center items-center'>
      <div className='rounded-full  cursor-pointer' onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <Info />
      </div>

      {isHovered && (
        <div className='absolute w-64 left-40 transform -translate-x-1/2 bg-light text-soft-black p-3'>
          The Exchange Rate could change till the payment request gets approved
        </div>
      )}
    </div>
  );
};
